import { dateService, FORMATS } from '@/global/services/date'
import { isFunction } from '@/global/utils/utils'

const TAB_KEY = 'documents'
export default {
  name: 'documents',

  computed: {
    documentsCreateConfig () {
      return {
        title: this.$t('people/person.documents'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            type: 'dynamic-columns',
            showInitialRows: 1,
            showButtons: false,
            bordered: false,
            title: this.$t('people/person.documents'),
            component: this.dynamicColumnsContentComponent,
            key: 'person_documents',
            display_props: ['person_document_id', 'valid_from', 'valid_to', 'alarm_on'],
            useInitialAutocompletes: true,
            headers: [this.$t('people/person_document.type'), this.$t('people/person_document.valid_from'), this.$t('people/person_document.valid_to'), this.$t('people/person_document.alarm_on')],
            fields: [
              {
                key: 'person_document_id',
                type: 'autocomplete',
                autocomplete_options: {
                  module: 'people',
                  route: 'person-documents/autocomplete'
                },
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'valid_from',
                type: 'datetime-picker',
                subType: 'date',
                appendIcon: 'mdi-calendar-month',
                format: FORMATS.date,
                placeholder: FORMATS.date,
                onInput: (value, event) => {
                  const { updateValidationErrors, collectionKey, collectionIndex } = event || {}

                  if (value && isFunction(updateValidationErrors) && !dateService.isValid(value, FORMATS.date, true)) {
                    updateValidationErrors({
                      [collectionKey + '.' + collectionIndex + '.valid_from']: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                    })
                  }
                },
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'valid_to',
                type: 'datetime-picker',
                subType: 'date',
                appendIcon: 'mdi-calendar-month',
                format: FORMATS.date,
                placeholder: FORMATS.date,
                onInput: (value, event) => {
                  const { updateValidationErrors, collectionKey, collectionIndex } = event || {}

                  if (value && isFunction(updateValidationErrors) && !dateService.isValid(value, FORMATS.date, true)) {
                    updateValidationErrors({
                      [collectionKey + '.' + collectionIndex + '.valid_to']: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                    })
                  }
                },
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'alarm_on',
                type: 'switch',
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  }
}
